import React, {useEffect} from "react"
import AudioFile from "./AudioFile"
import audioData from "./audioData.js"

function Audio(props) {

    useEffect(() => {
        audioData[props.pageId].map( file => {
            return document.getElementById(file.name).load()
        })
        
        if (props.pageId === props.gameEndId) {document.getElementById("noirSting").play()}
    }, [props.pageId, props.gameEndId])
            
    const audioFiles = audioData[props.pageId].map( clip => {
         return (
        <div key={clip.id}>
            <AudioFile key={clip.id} name={clip.name} audioSource={clip.audioSource} />
        </div>
        )
    })
    
    return (
        <div>
            <AudioFile name={audioData[0][0].name} audioSource={audioData[0][0].audioSource} />
            {audioFiles}
        </div>
    )
}

export default Audio